import { parse } from 'querystring';
import { getIn } from 'seamless-immutable';
import { formatFilters } from '@catalogo/core-filters/src/helpers';
import query from './one-day-delivery.graphql';

export const setOneDayDeliveryFiltered = (cache, req) => {
  const search = req ? getIn(req, ['_parsedUrl', 'search']) : getIn(window, ['location', 'search']);

  const queryString = search ? parse(search.replace('?', '')) : {};
  const oddFromFilter = formatFilters(search).find(({ id }) => id === 'one_day_delivery');

  const oneDayDeliveryFiltered = !!queryString['oneDayDeliveryFiltered'] || !!oddFromFilter;

  cache.writeQuery({
    query,
    data: { oneDayDeliveryFiltered: oneDayDeliveryFiltered },
  });
};
